module.exports = __webpack_public_path__ + "img/app-store.60c34269.jpg";